var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "form",
      {
        staticClass: "mb-2",
        on: {
          submit: function($event) {
            $event.preventDefault()
            return _vm.validateBeforeSubmit.apply(null, arguments)
          }
        }
      },
      [
        _c(
          "div",
          {
            class: [
              "form-group",
              { "is-invalid": _vm.$v.loginData.email.$error }
            ]
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.loginData.email,
                  expression: "loginData.email",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.$v.loginData.email.$error },
              attrs: { placeholder: "Введите Email...", type: "email" },
              domProps: { value: _vm.loginData.email },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(_vm.loginData, "email", $event.target.value.trim())
                  },
                  function($event) {
                    return _vm.$v.loginData.email.$touch()
                  }
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            !_vm.$v.loginData.email.required
              ? _c("span", { staticClass: "invalid-feedback" }, [
                  _vm._v("\n    Требуется ввести Email\n  ")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.loginData.email.email
              ? _c("span", { staticClass: "invalid-feedback" }, [
                  _vm._v("\n    Некорректный Email\n  ")
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            class: [
              "form-group",
              { "is-invalid": _vm.$v.loginData.password.$error }
            ]
          },
          [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model.trim",
                  value: _vm.loginData.password,
                  expression: "loginData.password",
                  modifiers: { trim: true }
                }
              ],
              staticClass: "form-control",
              class: { "is-invalid": _vm.$v.loginData.password.$error },
              attrs: { placeholder: "Введите пароль...", type: "password" },
              domProps: { value: _vm.loginData.password },
              on: {
                input: [
                  function($event) {
                    if ($event.target.composing) {
                      return
                    }
                    _vm.$set(
                      _vm.loginData,
                      "password",
                      $event.target.value.trim()
                    )
                  },
                  function($event) {
                    return _vm.$v.loginData.password.$touch()
                  }
                ],
                blur: function($event) {
                  return _vm.$forceUpdate()
                }
              }
            }),
            _vm._v(" "),
            !_vm.$v.loginData.password.required
              ? _c("span", { staticClass: "invalid-feedback" }, [
                  _vm._v("\n    Требуется ввести пароль\n  ")
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.$v.loginData.password.minLength
              ? _c("span", { staticClass: "invalid-feedback" }, [
                  _vm._v(
                    "\n    Пароль должен быть не менее " +
                      _vm._s(_vm.$v.loginData.password.$params.minLength.min) +
                      " символов.\n  "
                  )
                ])
              : _vm._e()
          ]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "other-actions row" }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn btn-theme btn-full",
            staticStyle: {
              "background-color": "#204694",
              "border-color": "#204694"
            }
          },
          [_vm._v("Войти")]
        )
      ]
    ),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("a", { staticClass: "mt-2", attrs: { href: "/google-auth" } }, [
      _c(
        "button",
        {
          staticClass: "btn btn-theme btn-full",
          staticStyle: {
            "background-color": "#204694",
            "border-color": "#204694"
          }
        },
        [_vm._v("\n            Войти с помощью Google\n            ")]
      )
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46ec553e", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46ec553e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/views/auth/Login.vue
// module id = 835
// module chunks = 0